import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SubscriptionHistorySkeleton = () => {
  return (
    <>
      {/* Header */}
      <div className="history-header">
        <Skeleton circle width={42} height={42} />
        <Skeleton width={180} height={28} />
      </div>

      {/* History Cards */}
      {Array.from({ length: 5 }).map((_, index) => (
        <div className="history-card" key={index}>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 15
            }}
          >
            <Skeleton width={160} height={22} />
            <Skeleton width={90} height={28} borderRadius={20} />
          </div>

          <Skeleton width="55%" height={16} />
          <Skeleton
            width="40%"
            height={16}
            style={{ marginTop: 10 }}
          />

          <Skeleton
            height={1}
            style={{ margin: "18px 0" }}
          />

          <Skeleton width="70%" height={15} />
          <Skeleton
            width="50%"
            height={15}
            style={{ marginTop: 8 }}
          />

        </div>
      ))}
    </>
  );
};

export default SubscriptionHistorySkeleton;